var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder_1_",
    "data-name": "folder (1)",
    transform: "translate(0 -30.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464",
    transform: "translate(1.695 30.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22538",
    "data-name": "Path 22538",
    d: "M27.744,43.2l11.344-5.355h-3.2l-4.849-4.133a1.113,1.113,0,0,0-.8-.3h-7.97A1.242,1.242,0,0,0,21,34.683V43.2Z",
    transform: "translate(-20.997 -33.418)",
    fill: "#0078d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22539",
    "data-name": "Path 22539",
    d: "M404.916,93.63h3.458V89.54a1.242,1.242,0,0,0-1.265-1.265h-4.723Z",
    transform: "translate(-370.755 -83.847)",
    fill: "#0078d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22540",
    "data-name": "Path 22540",
    d: "M116.5,31.252a1.465,1.465,0,0,0-1.982-.675L93.1,40.7h27.832Z",
    transform: "translate(-84.734 0)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22541",
    "data-name": "Path 22541",
    d: "M40.656,152.4a1.33,1.33,0,0,0-.947-.391H1.3a1.33,1.33,0,0,0-.947.391,1.157,1.157,0,0,0-.345.955L1.3,176.984A1.284,1.284,0,0,0,2.592,178.2H38.417a1.284,1.284,0,0,0,1.292-1.216L41,153.36A1.525,1.525,0,0,0,40.656,152.4Z",
    transform: "translate(0 -111.78)",
    fill: "#4d8de0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.84a221aed16c2549ebfed902e6c5ac6d.svg";
export { ForwardRef as ReactComponent };